import { ApiHttpClient } from "@/core/common/http/api-http-client";
import { ResourceBaseService } from "@/core/common/resource-base/resource-base.service";
import { OptionType } from "@/types/OptionType";
import { getOptionLoader } from "@/core/common/presenters/optionLoader";
import { PointPaidPositionDto } from "@/core/features/point-paid-positions/point-paid-position.dto";
import { CreatePointPaidPositionDto } from "@/core/features/point-paid-positions/create-point-paid-position.dto";
import { UpdatePointPaidPositionDto } from "@/core/features/point-paid-positions/update-point-paid-position.dto";

export class PointPaidPositionsResource extends ResourceBaseService<
  PointPaidPositionDto,
  CreatePointPaidPositionDto,
  UpdatePointPaidPositionDto
> {
  protected EntityDto = PointPaidPositionDto;
  protected CreateEntityDto = CreatePointPaidPositionDto;
  protected UpdateEntityDto = UpdatePointPaidPositionDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/point-paid-positions");
  }

  async optionLoader(inputValue: string): Promise<OptionType[]> {
    return getOptionLoader(
      inputValue,
      ["id", "name"],
      [{ field: "name", order: "ASC" }],
      (request) => this.findAll(request),
      ["name"]
    );
  }
}
